import React from 'react';
import { Button } from '@/components/ui/button';

import type { ProgramControlCommonProps } from '../controlTypes';

type MistProgramControlsProps = ProgramControlCommonProps & {
  mistReportLoading: null | 'active' | 'released' | 'all';
  onDownloadMistReport: (reportType: 'active' | 'released' | 'all') => void;
};

export const MistProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  mistReportLoading,
  onDownloadMistReport,
}: MistProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-y-3 [&>div+div]:ml-6 [&>div+div]:border-l [&>div+div]:border-[var(--neutral-gray-70)] [&>div+div]:pl-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">
          Released
        </div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="mist-released"
              value="all"
              checked={values.mistReleasedFilter === 'all'}
              onChange={() => onFilterChange('mistReleasedFilter', 'all')}
            />
            All
          </label>
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="mist-released"
              value="y"
              checked={values.mistReleasedFilter === 'y'}
              onChange={() => onFilterChange('mistReleasedFilter', 'y')}
            />
            Yes
          </label>
          <label className="flex items-center gap-1.5">
            <input
              type="radio"
              name="mist-released"
              value="n"
              checked={values.mistReleasedFilter === 'n'}
              onChange={() => onFilterChange('mistReleasedFilter', 'n')}
            />
            No
          </label>
        </div>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8"
        onClick={() => onDownloadMistReport('active')}
        disabled={mistReportLoading !== null}
      >
        {renderReportActionLabel('All Fields Report-Active')}
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8"
        onClick={() => onDownloadMistReport('released')}
        disabled={mistReportLoading !== null}
      >
        {renderReportActionLabel('All Fields Report-Released')}
      </Button>
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onDownloadMistReport('all')}>
        {renderReportActionLabel('All')}
      </Button>
    </div>
  </div>
);
